import get from 'lodash/get'
import {createSelector} from 'reselect'

import {orderPromoCode, orderSummaryIsPending} from './checkout'
import {isQualified} from './groomRentsFree'

export const currentlyAppliedPromoCode = (state) =>
  get(state, 'promo.currentlyAppliedPromoCode', '')
export const hasError = (state) => get(state, 'promo.hasError', false)
export const isOverrideVisible = (state) => get(state, 'promo.isOverrideVisible', false)
export const statusMessage = (state) => get(state, 'promo.statusMessage', '')
export const isApplyPromoCodePending = (state) => get(state, 'promo.isApplyPromoCodePending', false)

export const shouldShowDiscountMessaging = createSelector(
  orderSummaryIsPending,
  hasError,
  currentlyAppliedPromoCode,
  isQualified,
  orderPromoCode,
  (orderPending, promoHasError, appliedPromo, isGroomRentsFreeQualified, orderPromo) =>
    !!(
      !appliedPromo &&
      isGroomRentsFreeQualified &&
      !orderPromo &&
      !orderPending &&
      !promoHasError
    ),
)
